import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JBImage from 'components/essentials/JBImage';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import Link from 'components/consumer/Link';
import ToggleCTALinkButton from 'components/essentials/ToggleCTALinkButton';
import ToggleCTAImageLink from './ToggleCTAImageLink';
const HalfImage = t0 => {
  const $ = _c(3);
  const {
    imageProps
  } = t0;
  let t1;
  if ($[0] !== imageProps.alt || $[1] !== imageProps.src) {
    t1 = <JBImage src={imageProps.src} alt={imageProps.alt} className="half-image" crop="focalpoint" fpY={0.7} sizes="(max-width: 767px) 100vw, 50vw" />;
    $[0] = imageProps.alt;
    $[1] = imageProps.src;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
HalfImage.propTypes = {
  imageProps: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.string
  }).isRequired
};
const LinkHalfImage = t0 => {
  const $ = _c(5);
  const {
    to,
    imageProps
  } = t0;
  let t1;
  if ($[0] !== imageProps) {
    t1 = <HalfImage imageProps={imageProps} />;
    $[0] = imageProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== to) {
    t2 = <Link to={to}>{t1}</Link>;
    $[2] = t1;
    $[3] = to;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
LinkHalfImage.propTypes = {
  to: PropTypes.string.isRequired,
  imageProps: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string.isRequired
  }).isRequired
};
const HalfImageHalfText = t0 => {
  const $ = _c(35);
  const {
    config: t1
  } = t0;
  const {
    imageProps,
    heading,
    subText,
    toggleInputType,
    imageOrientation
  } = t1;
  let finalOrientation = "default";
  if (imageOrientation && imageOrientation.value) {
    finalOrientation = imageOrientation.value !== "Image Left" ? "alt" : "default";
  }
  const HeaderTag = heading.tagName || "div";
  const t2 = finalOrientation === "default";
  const t3 = finalOrientation === "alt";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames("flex [&_a:hover]:underline", {
      "flex-row max-[767px]:flex-col": t2,
      "flex-row-reverse max-[767px]:flex-col": t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = finalOrientation === "default";
  const t6 = finalOrientation === "alt";
  let t7;
  if ($[3] !== t5 || $[4] !== t6) {
    t7 = classNames({
      "md:mr-16": t5,
      "md:ml-16": t6
    });
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== imageProps || $[7] !== toggleInputType) {
    t8 = <ToggleCTAImageLink toggleInputType={toggleInputType} imageProps={imageProps} />;
    $[6] = imageProps;
    $[7] = toggleInputType;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = finalOrientation === "default" || finalOrientation === "alt";
  let t11;
  if ($[12] !== t10) {
    t11 = classNames("w-1/2 max-[767px]:w-full [&_img]:w-full [&_img]:align-middle [&_img]:[transition:all_.25s_ease-in-out] flex flex-row !m-0", {
      "max-[767px]:pt-6": t10
    });
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== heading.content) {
    t12 = {
      __html: heading.content
    };
    $[14] = heading.content;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== HeaderTag || $[17] !== t12) {
    t13 = <HeaderTag className="text-2xl font-bold text-gray" dangerouslySetInnerHTML={t12} />;
    $[16] = HeaderTag;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== subText.content) {
    t14 = <div className="text-base text-gray mx-0 my-6" dangerouslySetInnerHTML={{
      __html: subText.content
    }} />;
    $[19] = subText.content;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== heading || $[22] !== toggleInputType) {
    t15 = !!toggleInputType && <ToggleCTALinkButton toggleInputType={toggleInputType} heading={heading} />;
    $[21] = heading;
    $[22] = toggleInputType;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t13 || $[25] !== t14 || $[26] !== t15) {
    t16 = <div className="w-full flex flex-col content-center justify-center font-sans max-[767px]:w-full">{t13}{t14}{t15}</div>;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t11 || $[29] !== t16) {
    t17 = <div className={t11}>{t16}</div>;
    $[28] = t11;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17 || $[32] !== t4 || $[33] !== t9) {
    t18 = <FixedWidthContainer className={t4}>{t9}{t17}</FixedWidthContainer>;
    $[31] = t17;
    $[32] = t4;
    $[33] = t9;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  return t18;
};
HalfImageHalfText.propTypes = {
  config: PropTypes.shape({
    cta: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string
    }),
    heading: PropTypes.shape({
      content: PropTypes.string,
      tagName: PropTypes.string
    }),
    imageOrientation: PropTypes.shape({
      value: PropTypes.string
    }),
    imageProps: PropTypes.shape({
      alt: PropTypes.string,
      src: PropTypes.string
    }),
    subText: PropTypes.shape({
      content: PropTypes.string
    }),
    toggleInputType: PropTypes.shape({
      ctaLink: PropTypes.shape({
        linkTo: PropTypes.string
      }),
      inputType: PropTypes.string
    })
  })
};
const HalfImageHalfTextUI = props => {
  const $ = _c(7);
  if (props?.config?.elementAttribute?.id) {
    const t0 = props?.config?.elementAttribute?.id;
    let t1;
    if ($[0] !== props) {
      t1 = <HalfImageHalfText {...props} />;
      $[0] = props;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
      t2 = <div id={t0}>{t1}</div>;
      $[2] = t0;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t0;
  if ($[5] !== props) {
    t0 = <HalfImageHalfText {...props} />;
    $[5] = props;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
};
HalfImageHalfTextUI.propTypes = {
  config: PropTypes.shape({
    elementAttribute: PropTypes.shape({
      id: PropTypes.string
    })
  })
};
export default HalfImageHalfTextUI;